<script>
    import Performers from './performers.svelte';
    import ActorsModels from './actorsModels.svelte';
    import MotionRecoding from './motionRecoding.svelte';
    import VoiceOverArtists from './voiceOverArtists.svelte';
    import Choreography from './choreography.svelte';
    import MobileNavbar from '../../reusableitems/mobileNavbar.svelte';
</script>
<div class="navbar">
    <MobileNavbar />
  </div>
  <div>
    <Performers/>
    <ActorsModels/>
    <MotionRecoding/>
    <VoiceOverArtists/>
    <Choreography/>
  </div>

  <style>
    .navbar{
        width: 100%;
    position: fixed;
    z-index: 10;
    }
  </style>